/* JellyChic · the gift page (templates/product.gift.json, sections/jc-gl-*.liquid). Vanilla, no dependencies.
   The buy box (sections/jc-product.liquid + assets/jc.js) owns the colour and the set; this file reads them (the
   form's data-count, the colour name, the set's totals) and dresses the page for a gift:
   - Gift buttons ([data-jc-gl-label]) say who it's for: "Send Lilas to your sister", "Treat yourself to Lilas",
     "Take both". Who it's for comes from the gift finder, a link (?for=<key>) or this visitor's last answer.
   - The gift bar ([data-jc-gl-bar]) shows once every gift button and the buy box's button are off screen.
   - Him and his dust bag ([data-jc-gl-scene]): the pop (the hero plays it on its own in CSS once the photo is in),
     a hop into a new colour (the photo swaps at the top of the jump), a squish on tap.
   - The finder, the story phone, the delivery calendar and order-by dates, the set cards, the final checklist.
   jc.js loads after the sections, so the reading starts at DOMContentLoaded. Reduced motion: no pop, hop, squish,
   autoplay or draw-in; every moment shows its resting state. */
(function () {
  'use strict';
  if (window.jcGl) { window.jcGl.boot(document); return; }

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  function still() { return RM.matches; }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function json(el) { try { return JSON.parse((el && el.textContent) || 'null'); } catch (e) { return null; } }
  function track(name, detail) {
    window.dataLayer = window.dataLayer || [];
    var p = { event: 'jc_' + name };
    if (detail) Object.keys(detail).forEach(function (k) { p[k] = detail[k]; });
    window.jcPush(p);
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } return null; }
  function inView(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight && r.width > 0; }
  var lang = document.documentElement.lang || 'en';
  var dateLang = /^en/i.test(lang) ? 'en-GB' : lang;

  /* ---------- Data: the colours, money in her currency ---------- */
  var D = null, bySlug = {}, byName = {}, rate = 1, money = function (c) { return String(Math.round(c / 100)); };
  function moneyFormatter(sample) {
    var prefix = '', suffix = '', grp = ',';
    var m = sample && sample.match(/^(.*?)(\d[\d.,\s]*\d|\d)(.*)$/);
    if (m) {
      prefix = m[1]; suffix = m[3];
      if (/\.\d{3}/.test(m[2]) && !/,\d{3}/.test(m[2])) grp = '.';
      else if (/\s\d{3}/.test(m[2])) grp = ' ';
      if (window.jcMoneyGrp) grp = window.jcMoneyGrp;   // her currency's own thousands separator (layout/theme.liquid)
    }
    return function (sub) { return prefix + window.jcNum(sub, grp) + suffix; };
  }
  function readData() {
    if (D) return D;
    D = json($('[data-jc-gl-data]'));
    if (!D) return null;
    (D.colours || []).forEach(function (c) { bySlug[c.slug] = c; byName[c.name] = c; });
    money = moneyFormatter(D.unitText);
    rate = D.currency && D.shopCurrency && D.currency === D.shopCurrency ? 1 : (parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
    D.comp = {};
    String(D.complements || '').split(/\n/).forEach(function (l) {
      var p = l.split(':');
      if (p.length > 1) D.comp[p[0].trim()] = p[1].split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    });
    return D;
  }
  /* The set discounts, like the product page: 2 bags → the 2-bag discount; 3+ → the 3-bag discount's share on every bag */
  function off(n) {
    return window.jcSetOff((D && D.offs) || {}, n, rate);   // bag by bag, like checkout (layout/theme.liquid)
  }
  /* Colours that go with her colour: the theme's complements, then the bestsellers, then the rest (available only) */
  function partners(slug) {
    var want = (D.comp[slug] || []).concat(D.bestsellers || [], (D.colours || []).map(function (c) { return c.slug; }));
    var out = [];
    want.forEach(function (w) { if (w && w !== slug && out.indexOf(w) < 0 && bySlug[w] && bySlug[w].available) out.push(w); });
    return out;
  }
  function cutSrc(c, w) { return c.cutout + (c.cutout.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---------- State: the buy box's colour and set, and who it's for ---------- */
  var S = { slug: null, count: 1, who: null, names: [] };
  var L = { one: 'Send [colour] [to]', self: 'Treat yourself to [colour]', two: 'Take both', many: 'Take all [count]', bar: 'Send him', barSelf: 'Take him home', barLine: 'For [for] · [colours]', barLineSelf: 'For you · [colours]', to: 'to her', 'for': 'her', added: 'Added ✓' };
  var WHO = {};           // key → the finder's "Who it's for" blocks
  function fold() { return $('product-component.jc-product [data-jc-bundle]'); }
  function foldRoot() { var f = fold(); return f ? f.closest('product-component') : null; }
  function readState() {
    var f = fold();
    if (f) {
      S.count = parseInt(f.getAttribute('data-count') || f.getAttribute('data-tier') || '1', 10) || 1;
      var nm = $('[data-jc-colour-name]', foldRoot());
      var c = nm && byName[nm.textContent.trim()];
      if (c) S.slug = c.slug;
      S.names = [];
      for (var i = 1; i <= S.count; i++) {
        var el = $('[data-jc-slot-label="' + i + '"]', f);
        S.names.push(i === 1 ? (c ? c.name : '') : (el ? el.textContent.trim() : ''));
      }
    }
    if (!S.slug) S.slug = D.current;
    if (!S.names.length || !S.names[0]) S.names = [(bySlug[S.slug] || {}).name || ''];
  }
  function who() { return S.who || {}; }
  function forWord() { var w = who(); return w.key ? (w['for'] || L['for']) : L['for']; }
  function toWord() { var w = who(); return w.key ? (w.to || '') : L.to; }
  function handle() { var w = who(); return w.key ? (w.handle || L['for']) : null; }
  function colourNames() {
    var n = S.names.filter(Boolean);
    return n.length > 3 ? n.slice(0, 3).join(' + ') + ' +' + (n.length - 3) : n.join(' + ');
  }
  function label(kind) {
    var c = bySlug[S.slug] || {}, w = who();
    if (kind === 'bar') {
      if (S.count === 2) return L.two;
      if (S.count > 2) return L.many.replace('[count]', S.count);
      return (w.self ? L.barSelf : L.bar).replace('[colour]', c.name || '');
    }
    if (S.count === 2) return L.two;
    if (S.count > 2) return L.many.replace('[count]', S.count);
    if (w.self) return L.self.replace('[colour]', c.name || '');
    return L.one.replace('[colour]', c.name || '').replace('[to]', toWord()).replace(/\s+/g, ' ').trim();
  }
  function totalText() {
    var root = foldRoot();
    var el = root && $('[data-jc-tier-price="' + Math.min(S.count, 3) + '"]', root);
    if (el && el.textContent.trim()) return el.textContent.trim();
    var c = bySlug[S.slug];
    return c ? money(c.price * S.count - off(S.count)) : '';
  }
  function setWho(key, source) {
    var w = WHO[key];
    if (!w) return;
    S.who = w;
    store('jc-gl-for', key);
    render();
    track('gift_for', { jc_for: key, source: source || 'finder' });
  }

  /* ---------- Paint: labels, the bar, "for her", the story's handle ---------- */
  var addedUntil = 0;
  var painted = false;
  function render() {
    if (!readData()) return;
    var prev = painted ? S.slug : null;
    painted = true;
    readState();
    $$('[data-jc-gl-label]').forEach(function (el) {
      var btn = el.closest('button');
      if (btn && btn.classList.contains('is-added')) return;
      var t = label(el.getAttribute('data-jc-gl-label') === 'bar' ? 'bar' : 'main');
      setText(el, t);
      if (btn) btn.classList.toggle('is-long', t.length > 27);
    });
    var c = bySlug[S.slug];
    if (c) $$('[data-jc-gl-add]').forEach(function (b) {
      if (b.getAttribute('data-jc-add-variant') !== String(c.variant)) b.setAttribute('data-jc-add-variant', c.variant);
      if (b.getAttribute('data-jc-add-face') !== c.face) b.setAttribute('data-jc-add-face', c.face);
    });
    $$('[data-jc-gl-for]').forEach(function (el) { setText(el, forWord()); });
    $$('[data-jc-gl-setline]').forEach(function (el) { el.hidden = S.count < 2; setText(el, S.count > 1 ? colourNames() + ' · ' + totalText() : ''); });
    var h = handle();
    if (h) $$('[data-jc-gl-handle]').forEach(function (el) { setText(el, h); });
    // The buy box's own button speaks gift too (one bag; jc.js writes the set labels itself)
    var root = foldRoot(), fl = root && $('[data-jc-add-label]', root), fb = fl && fl.closest('button');
    if (fl && S.count === 1 && who().key && fb && !fb.classList.contains('is-added') && !fb.disabled) setText(fl, label('main'));
    renderBar();
    if (prev && prev !== S.slug) onColour(prev, S.slug);
    else if (!prev) onColour(null, S.slug);
  }
  function renderBar() {
    var bar = $('[data-jc-gl-bar]');
    if (!bar) return;
    var c = bySlug[S.slug];
    var img = $('[data-jc-gl-face]', bar);
    if (img && c && img.getAttribute('src') !== c.face) img.src = c.face;
    var n = $('[data-jc-gl-count]', bar);
    if (n) { n.hidden = S.count < 2; setText(n, S.count > 1 ? '+' + (S.count - 1) : ''); }
    setText($('[data-jc-gl-barline]', bar), (who().self ? L.barLineSelf : L.barLine).replace('[for]', forWord()).replace('[colours]', colourNames()));
    setText($('[data-jc-gl-total]', bar), totalText());
  }
  var raf = 0;
  function schedule() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; render(); }); }

  /* ---------- The colour changed: he hops into it everywhere ---------- */
  var colourSubs = [];
  function onColour(from, to) { colourSubs.forEach(function (fn) { try { fn(from, to); } catch (e) { /* one moment never breaks the rest */ } }); }

  /* ---------- Him and his dust bag ---------- */
  function rest(sc) { sc.classList.remove('is-in', 'is-play', 'is-auto', 'is-loaded', 'is-hop', 'is-squish'); sc._busy = false; }
  function swapImg(sc, c) {
    var img = $('[data-jc-gl-img]', sc);
    if (!img || !c) return;
    img.srcset = [360, 480, 720, 1000].map(function (w) { return cutSrc(c, w) + ' ' + w + 'w'; }).join(', ');   // same widths as snippets/jc-gl-scene
    img.src = cutSrc(c, 720);
    sc._slug = c.slug;
  }
  function sceneColour(sc, slug, hop) {
    var c = bySlug[slug];
    if (!c || sc._slug === slug) return;
    if (!hop || still() || !inView(sc) || sc._busy) { swapImg(sc, c); return; }
    var pre = new Image(), done = false;
    function go() {
      if (done) return;
      done = true;
      rest(sc);
      void sc.offsetWidth;
      sc.classList.add('is-hop');
      sc._busy = true;
      setTimeout(function () { swapImg(sc, c); }, 290);
      setTimeout(function () { sc.classList.remove('is-hop'); sc._busy = false; }, 760);
    }
    pre.onload = go; pre.onerror = go;
    pre.src = cutSrc(c, 720);
    setTimeout(go, 700);
  }
  function pop(sc) {
    if (!sc || still() || !sc.classList.contains('has-pouch')) return;
    rest(sc);
    sc.classList.add('is-in');
    void sc.offsetWidth;
    sc.classList.add('is-play');
    sc._busy = true;
    clearTimeout(sc._t);
    sc._t = setTimeout(function () { rest(sc); }, 1250);
  }
  function squish(sc) {
    if (!sc || still() || sc._busy) return;
    sc.classList.remove('is-squish');
    void sc.offsetWidth;
    sc.classList.add('is-squish');
    clearTimeout(sc._sq);
    sc._sq = setTimeout(function () { sc.classList.remove('is-squish'); }, 650);
  }
  function initScenes(scope) {
    $$('[data-jc-gl-scene]', scope).forEach(function (sc) {
      if (sc._jcgl) return;
      sc._jcgl = true;
      var img = $('[data-jc-gl-img]', sc);
      var m = img && (img.getAttribute('src') || '').match(/jc-bag-([a-z-]+?)\.png/);
      sc._slug = m ? m[1] : null;
      if (sc.classList.contains('is-auto')) {
        // The CSS pop (hero): tidy up when it ends, or now if it already has
        sc._busy = true;
        img.addEventListener('animationend', function (e) { if (e.animationName === 'jc-gl-pop' || e.animationName === 'jc-gl-safe') rest(sc); });
        var running = img.getAnimations && img.getAnimations().some(function (a) { return a.playState === 'running'; });
        if (sc.classList.contains('is-loaded') && img.getAnimations && !running) rest(sc);
        // Never stuck busy: once the photo is in, the pop is over within 1.6 s
        var late = function () { setTimeout(function () { if (sc.classList.contains('is-auto')) rest(sc); }, 2400); };
        if (img.complete && img.naturalWidth) late(); else img.addEventListener('load', late, { once: true });
      }
    });
  }

  /* ---------- The gift bar: only when no other way to buy is on screen ---------- */
  function initBar() {
    var bar = $('[data-jc-gl-bar]');
    if (!bar || bar._jcgl || !('IntersectionObserver' in window)) return;
    bar._jcgl = true;
    var wide = window.matchMedia('(min-width: 1024px)');
    var seen = new Map(), footOn = false, scrolled = window.scrollY > 240;
    var btn = $('button', bar);
    function paint() {
      var any = false;
      seen.forEach(function (v) { if (v) any = true; });
      var show = !any && !footOn && (!wide.matches || scrolled) && !$('cart-drawer.active');
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
    }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { seen.set(e.target, e.isIntersecting && e.intersectionRatio >= 0.6); }); paint(); }, { threshold: [0, 0.6, 1] });
    var root = foldRoot();
    $$('[data-jc-gl-cta]').concat(root ? $$('[data-jc-add]', root) : []).forEach(function (t) { seen.set(t, false); io.observe(t); });
    var foot = $('.jc-foot') || $('footer');
    if (foot) new IntersectionObserver(function (es) { es.forEach(function (e) { footOn = e.isIntersecting; }); paint(); }).observe(foot);
    window.addEventListener('scroll', function () { var s = window.scrollY > 240; if (s !== scrolled) { scrolled = s; paint(); } }, { passive: true });
    document.addEventListener('jc:added', function () { setTimeout(paint, 50); });
    paint();
  }

  /* ---------- 1 · Hero ---------- */
  function initHero(sec) {
    if (sec._jcgl) return;
    sec._jcgl = true;
    var sc = $('[data-jc-gl-scene]', sec);
    if (sc) {
      sc.addEventListener('click', function () { squish(sc); track('gift_hero_squish'); });
      colourSubs.push(function (from, to) { if (from) sceneColour(sc, to, true); else sceneColour(sc, to, false); });
    }
  }

  /* ---------- 2 · The gift finder ---------- */
  function initFinder(sec) {
    if (sec._jcgl) return;
    sec._jcgl = true;
    var cfg = json($('[data-jc-gl-fd-cfg]', sec)) || { who: [], matches: [] };
    var qs = { 1: $('[data-jc-gl-q="1"]', sec), 2: $('[data-jc-gl-q="2"]', sec), 3: $('[data-jc-gl-q="3"]', sec) };
    var res = $('[data-jc-gl-res]', sec), back = $('[data-jc-gl-fd-back]', sec), count = $('[data-jc-gl-fd-count]', sec);
    var bars = $$('.jc-gl-fd__bars i', sec), picker = $('[data-jc-gl-fd-picker]', sec), card = $('[data-jc-gl-fd-card]', sec);
    var scene = res && $('[data-jc-gl-scene]', res);
    var ans = { who: null, look: null, vibe: null };
    var step = qs[1] ? 1 : 2, shown = false, result = null;
    var matchBy = {};
    $$('[data-jc-gl-save]', sec).forEach(function (el) { var n = parseInt(el.getAttribute('data-jc-gl-save'), 10), v = off(n); setText(el, v >= 50 ? String(cfg.saveLabel || 'Save [saving]').replace('[saving]', money(v)) : ''); });
    (cfg.matches || []).forEach(function (m, i) { m.order = i; m.tags = String(m.tags || '').split(',').filter(Boolean); matchBy[m.slug] = m; });

    function go(n, focus) {
      step = n;
      [1, 2, 3].forEach(function (k) { if (qs[k]) qs[k].hidden = k !== n; });
      if (res) res.hidden = n !== 4;
      if (card) card.classList.toggle('is-result', n === 4);
      if (back) back.hidden = n === 4 || n === 1 || (n === 2 && !qs[1]);
      if (count) { count.hidden = n === 4; setText(count, String(cfg.step || '[n] of 3').replace('[n]', String(Math.min(n, 3)))); }
      bars.forEach(function (b, i) { b.classList.toggle('is-on', i < Math.min(n, 3)); });
      if (focus && n < 4 && qs[n]) { var first = $('.jc-gl-opt', qs[n]); if (first) first.focus({ preventScroll: true }); }
    }
    function tags() {
      var t = [];
      [ans.who && ans.who.tags, ans.look && ans.look.tags, ans.vibe && ans.vibe.tags].forEach(function (s) { String(s || '').split(',').forEach(function (x) { if (x) t.push(x); }); });
      return t;
    }
    function decide() {
      var t = tags();
      var list = (cfg.matches || []).filter(function (m) { return bySlug[m.slug] && bySlug[m.slug].available; }).map(function (m) {
        var score = 0;
        t.forEach(function (x) { if (m.tags.indexOf(x) > -1) score++; });
        return { m: m, score: score };
      });
      list.sort(function (a, b) { return b.score - a.score || a.m.order - b.m.order; });
      return list;
    }
    // The eleven thin out as she answers; the one chosen for her keeps the ring
    var faces = $$('.jc-gl-fd__f', sec);
    function narrow(keep, win) {
      var n = 0;
      faces.forEach(function (f) {
        var sl = f.getAttribute('data-slug'), c = bySlug[sl];
        var on = !!(c && c.available && (!keep || keep.indexOf(sl) > -1 || sl === win));
        f.classList.toggle('is-out', !on);
        f.classList.toggle('is-win', sl === win);
        if (on && keep && !still()) {
          f.style.setProperty('--dl', (n++ * 45) + 'ms');
          f.classList.remove('is-hop'); void f.offsetWidth; f.classList.add('is-hop');
        }
      });
    }
    function survivors(final) {
      if (!tags().length) return null;
      var l = decide(), max = l.length ? l[0].score : 0;
      if (!max) return null;
      return l.filter(function (r) { return final ? r.score === max : r.score > 0; }).map(function (r) { return r.m.slug; });
    }
    function why(slug) {
      var m = matchBy[slug];
      return (m && m.why) || cfg.whyFallback || '';
    }
    function fillResult(slug) {
      setText($('[data-jc-gl-res-why]', sec), why(slug));
      var alts = $('[data-jc-gl-res-altlist]', sec), box = $('[data-jc-gl-res-alts]', sec);
      if (alts && box && result) {
        var others = result.filter(function (r) { return r.m.slug !== slug; }).slice(0, 2);
        alts.innerHTML = '';
        others.forEach(function (r) {
          var c = bySlug[r.m.slug];
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'jc-gl-alt';
          b.setAttribute('data-jc-pick', c.slug);
          b.setAttribute('data-track', 'gift_finder_alt');
          b.innerHTML = '<span class="jc-gl-alt__face" style="--c: ' + c.hex + ';"><img src="' + c.face + '" alt="" width="72" height="72" loading="lazy"></span><span></span>';
          b.lastChild.textContent = c.name;
          alts.appendChild(b);
        });
        box.hidden = !others.length;
      }
    }
    function showResult() {
      result = decide();
      if (!result.length) return;
      var best = result[0].m.slug;
      shown = true;
      go(4);
      fillResult(best);
      narrow(survivors(true), best);
      var said = $('[data-jc-gl-res-said]', sec);
      if (said) {
        $$('b', said).forEach(function (b) { b.remove(); });
        [ans.look, ans.vibe].forEach(function (a) { if (a && a.label) { var b = document.createElement('b'); b.textContent = a.label; said.appendChild(b); } });
        said.hidden = !(ans.look || ans.vibe);
      }
      var set = $('[data-jc-gl-res-set]', sec);
      if (set) set.hidden = !(ans.who && ans.who.several);
      res.classList.remove('is-new');
      void res.offsetWidth;
      res.classList.add('is-new');
      // The page wears her colour (jc.js picks it in the buy box); he pops out of his dust bag in it
      if (scene) { var c = bySlug[best]; if (c) { rest(scene); swapImg(scene, c); } }
      if (picker) { picker.setAttribute('data-jc-pick', best); picker.click(); }
      if (!fold()) paintNoFold(best);
      if (scene) {
        var img = $('[data-jc-gl-img]', scene), fired = false;
        var start = function () { if (fired) return; fired = true; pop(scene); };
        if (img && !(img.complete && img.naturalWidth)) { img.addEventListener('load', start, { once: true }); setTimeout(start, 900); } else setTimeout(start, 120);
      }
      res.focus({ preventScroll: true });
      var r = card.getBoundingClientRect(), top = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--jc-nav-h')) || 64) + 12;
      if (r.top < top || r.top > window.innerHeight * 0.4) window.scrollBy({ top: r.top - top, behavior: still() ? 'auto' : 'smooth' });
      track('gift_finder_result', { colour: best, jc_for: ans.who ? ans.who.key : '' });
    }
    function press(group, btn) {
      $$('.jc-gl-opt', group).forEach(function (o) { o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'); });
    }
    if (qs[1]) qs[1].addEventListener('click', function (e) {
      var b = e.target.closest('[data-jc-gl-who]');
      if (!b) return;
      press(qs[1], b);
      ans.who = WHO[b.getAttribute('data-jc-gl-who')] || null;
      if (ans.who) setWho(ans.who.key, 'finder');
      go(2, true);
    });
    [2, 3].forEach(function (k) {
      if (!qs[k]) return;
      qs[k].addEventListener('click', function (e) {
        var b = e.target.closest('[data-jc-gl-ans]');
        if (!b) return;
        press(qs[k], b);
        ans[k === 2 ? 'look' : 'vibe'] = { tags: b.getAttribute('data-jc-gl-ans'), label: b.textContent.trim() };
        if (k === 2) { narrow(survivors(false), null); go(3, true); } else showResult();
      });
    });
    if (back) back.addEventListener('click', function () { go(Math.max(qs[1] ? 1 : 2, step - 1), true); });
    var again = $('[data-jc-gl-fd-restart]', sec);
    if (again) again.addEventListener('click', function () {
      ans.look = ans.vibe = null;
      shown = false;
      narrow(null, null);
      $$('[data-jc-gl-ans]', sec).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      go(qs[1] ? 1 : 2, true);
      var r = card.getBoundingClientRect();
      if (r.top < 0) card.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'start' });
    });
    // Who it's for already known (a link, or last time): pre-press it and start at question 2
    if (S.who && qs[1]) {
      ans.who = S.who;
      var pre = $('[data-jc-gl-who="' + S.who.key + '"]', qs[1]);
      if (pre) { press(qs[1], pre); if (new URL(location.href).searchParams.get('for')) step = 2; }
    }
    go(step);
    // A colour picked anywhere else: the result follows it (its own reason), and he hops into it
    colourSubs.push(function (from, to) {
      if (scene) sceneColour(scene, to, shown && !!from);
      if (shown) { fillResult(to); faces.forEach(function (f) { var on = f.getAttribute('data-slug') === to; f.classList.toggle('is-win', on); if (on) f.classList.remove('is-out'); }); }
    });
  }

  /* No buy box on the page (someone removed it in the editor): the finder and chips still paint the colour */
  function paintNoFold(slug) {
    var c = bySlug[slug];
    if (!c) return;
    document.documentElement.style.setProperty('--sw', c.hex);
    $$('[data-jc-colour-name]').forEach(function (el) { setText(el, c.name); });
    $$('[data-jc-strip]').forEach(function (b) { var on = b.getAttribute('data-jc-strip') === slug; b.classList.toggle('is-on', on); if (on) b.setAttribute('aria-pressed', 'true'); else b.removeAttribute('aria-pressed'); });
    var prev = S.slug;
    S.slug = slug;
    S.names = [c.name];
    render();
    if (prev !== slug) onColour(prev, slug);
  }

  /* ---------- 3 · The story phone ---------- */
  function initStory(sec) {
    if (sec._jcgl) return;
    sec._jcgl = true;
    var phone = $('[data-jc-gl-phone]', sec);
    if (!phone) return;
    var sc = $('[data-jc-gl-scene]', phone);
    var frames = [];
    if (sc && sc.classList.contains('has-pouch') && $('[data-show="1"]', phone)) frames.push(1);
    frames.push(2);
    if ($('.jc-gl-phone__photo', phone)) frames.push(3);
    frames.push(4);
    var DUR = { 1: 1700, 2: 2700, 3: 2200, 4: 4200 };
    var bars = $$('.jc-gl-phone__bars i', phone);
    bars.forEach(function (b, i) { if (i >= frames.length) b.remove(); });
    bars = bars.slice(0, frames.length);
    var idx = frames.length - 1, playing = false, timer = 0, armed = false, played = false, visible = false;
    function paintBars() {
      bars.forEach(function (b, i) { b.classList.toggle('is-past', i < idx); b.classList.toggle('is-now', i === idx); });
      phone.style.setProperty('--dur', DUR[frames[idx]] + 'ms');
      var nb = $('b', bars[idx]);
      if (nb && playing) { nb.style.animation = 'none'; void nb.offsetWidth; nb.style.animation = ''; }
    }
    function show(i) {
      idx = Math.max(0, Math.min(frames.length - 1, i));
      var f = frames[idx];
      phone.setAttribute('data-frame', String(f));
      paintBars();
      if (sc) {
        if (f === 1) { rest(sc); if (!still()) sc.classList.add('is-in'); }
        else if (f === 2 && playing) pop(sc);
        else if (sc.classList.contains('is-in') && !sc.classList.contains('is-play')) rest(sc);
      }
      clearTimeout(timer);
      if (playing && idx < frames.length - 1) timer = setTimeout(function () { show(idx + 1); }, DUR[f]);
      else if (playing) timer = setTimeout(function () { playing = false; phone.classList.remove('is-playing'); played = true; track('gift_story_done'); }, DUR[f]);
    }
    function play(from) {
      if (still()) return;
      playing = true;
      phone.classList.add('is-playing');
      show(from || 0);
    }
    function stop() { playing = false; clearTimeout(timer); phone.classList.remove('is-playing'); }
    $$('[data-jc-gl-phone-go]', phone).forEach(function (b) {
      b.addEventListener('click', function () {
        var d = parseInt(b.getAttribute('data-jc-gl-phone-go'), 10);
        if (d > 0 && idx === frames.length - 1) { stop(); if (still()) show(0); else play(0); return; }
        stop();
        show(idx + d);
        if (frames[idx] === 2 && sc && !still()) pop(sc);
      });
    });
    if (still() || !('IntersectionObserver' in window)) { show(frames.length - 1); return; }
    // Arm before she arrives (first frame waiting), play once half of it is in view, pause while it's away
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && !armed && !played) { armed = true; idx = 0; phone.setAttribute('data-frame', String(frames[0])); paintBars(); if (sc && frames[0] === 1) sc.classList.add('is-in'); } });
    }, { rootMargin: '0px 0px 60% 0px' }).observe(phone);
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible = e.isIntersecting && e.intersectionRatio >= 0.5;
        if (visible && armed && !played && !playing) { play(idx); track('gift_story_view'); }
        else if (!visible && playing) { stop(); }
      });
    }, { threshold: [0, 0.5] }).observe(phone);
    colourSubs.push(function (from, to) { if (sc) sceneColour(sc, to, !!from && !playing); });
  }

  /* ---------- 5 · Delivery: the calendar and the order-by dates ---------- */
  function ymd(d) { return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); }
  function addDays(d, n) { var r = new Date(d); r.setDate(r.getDate() + n); return r; }
  function wknd(d) { var w = d.getDay(); return w === 0 || w === 6; }
  function addBD(d, n) { var r = new Date(d); while (n > 0) { r = addDays(r, 1); if (!wknd(r)) n--; } return r; }
  function fmt(d, o) { try { return d.toLocaleDateString(dateLang, o || { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return d.toDateString(); } }
  function storeToday(tz) {
    var sign = String(tz || '+0000').charAt(0) === '-' ? -1 : 1;
    var mins = sign * (parseInt(String(tz).substr(1, 2), 10) * 60 + parseInt(String(tz).substr(3, 2), 10) || 0);
    var n = new Date();
    var t = new Date(n.getTime() + (n.getTimezoneOffset() + mins) * 60000);
    return new Date(t.getFullYear(), t.getMonth(), t.getDate());
  }
  function orderBy(cfg, today) {
    var out = [];
    (cfg.occasions || []).forEach(function (o) {
      var m = String(o.date || '').match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (!m) return;
      var day = new Date(+m[1], +m[2] - 1, +m[3]);
      if (ymd(day) <= ymd(today)) return;
      var by = addDays(day, -1), d = new Date(by);
      while (ymd(addBD(d, cfg.max)) > ymd(by) && ymd(d) >= ymd(today)) d = addDays(d, -1);
      var late = ymd(d) < ymd(today);
      out.push({ name: o.name, day: day, by: d, late: late });
    });
    out.sort(function (a, b) { return a.day - b.day; });
    return out;
  }
  function initArrive(sec) {
    if (sec._jcgl) return;
    sec._jcgl = true;
    var cfg = json($('[data-jc-gl-arrive-cfg]', sec));
    if (!cfg || !cfg.show || !cfg.max) return;
    var today = storeToday(cfg.tz);
    var from = addBD(today, cfg.min || cfg.max), to = addBD(today, cfg.max);
    var occ = orderBy(cfg, today);
    // The calendar: from this week's Monday to the week he could arrive by (an occasion close by shows too)
    var cal = $('[data-jc-gl-cal]', sec), grid = $('[data-jc-gl-cal-grid]', sec);
    if (cal && grid) {
      var start = addDays(today, -((today.getDay() + 6) % 7));
      var end = new Date(to);
      occ.forEach(function (o) { if (ymd(o.day) <= ymd(addDays(start, 41)) && o.day > end) end = new Date(o.day); });
      var weeks = Math.min(6, Math.max(3, Math.ceil(((end - start) / 86400000 + 1) / 7)));
      var occKeys = {};
      occ.forEach(function (o) { occKeys[ymd(o.day)] = o.name; });
      var html = '';
      for (var w = 0; w < 7; w++) html += '<span class="jc-gl-cal__dow" aria-hidden="true">' + fmt(addDays(start, w), { weekday: 'narrow' }) + '</span>';
      var c = bySlug[S.slug] || {};
      for (var i = 0; i < weeks * 7; i++) {
        var d = addDays(start, i), k = ymd(d), cls = ['jc-gl-cal__d'];
        if (k < ymd(today)) cls.push('is-past');
        if (k === ymd(today)) cls.push('is-today');
        if (wknd(d)) cls.push('is-wknd');
        if (k >= ymd(from) && k <= ymd(to)) cls.push('is-win');
        if (occKeys[k]) cls.push('is-occ');
        var face = k === ymd(to) && c.face ? '<span class="jc-gl-cal__face" aria-hidden="true"><img data-jc-face src="' + c.face + '" alt="" width="60" height="60"></span>' : '';
        html += '<span class="' + cls.join(' ') + '"' + (occKeys[k] ? ' title="' + String(occKeys[k]).replace(/"/g, '&quot;') + '"' : '') + '>' + d.getDate() + face + '</span>';
      }
      grid.innerHTML = html;
      var endShown = addDays(start, weeks * 7 - 1);
      setText($('[data-jc-gl-cal-month]', sec), start.getMonth() === endShown.getMonth() ? fmt(start, { month: 'long', year: 'numeric' }) : fmt(start, { month: 'short' }) + ' – ' + fmt(endShown, { month: 'short', year: 'numeric' }));
      setText($('[data-jc-gl-cal-sr]', sec), String(cfg.srLine || '').replace('[from]', fmt(from, { weekday: 'long', day: 'numeric', month: 'long' })).replace('[to]', fmt(to, { weekday: 'long', day: 'numeric', month: 'long' })));
      cal.hidden = false;
    }
    // Order by, per occasion (never a countdown: a date)
    var list = $('[data-jc-gl-occ]', sec);
    var verify = cfg.verified ? '' : ' <span class="jc-tag jc-tag--demo">Verify</span>';
    if (list) {
      var rows = occ.filter(function (o) { return !o.late || cfg.late; }).slice(0, 3);
      list.innerHTML = rows.map(function (o) {
        var by = o.late ? String(cfg.late) : String(cfg.orderBy || 'Order by [date]').replace('[date]', fmt(o.by));
        return '<li><span class="jc-gl-occ__n"></span><span class="jc-gl-occ__d">' + fmt(o.day, { weekday: 'short', day: 'numeric', month: 'long' }) + '</span><span class="jc-gl-occ__by"><b></b>' + verify + '</span></li>';
      }).join('');
      $$('li', list).forEach(function (li, i) {
        var o = rows[i];
        setText($('.jc-gl-occ__n', li), o.name);
        setText($('.jc-gl-occ__by b', li), o.late ? String(cfg.late) : String(cfg.orderBy || 'Order by [date]').replace('[date]', fmt(o.by)));
      });
      list.hidden = !rows.length;
    }
    // The hero's one line: the nearest occasion she can still make
    var next = occ.filter(function (o) { return !o.late; })[0];
    var when = $('[data-jc-gl-when]');
    if (when && next && cfg.heroLine) {
      var a = $('a', when);
      if (a) a.setAttribute('href', '#' + (cfg.anchor || 'arrive'));
      setText($('[data-jc-gl-when-text]', when), String(cfg.heroLine).replace('[occasion]', next.name).replace('[date]', fmt(next.by)));
      var tag = $('.jc-tag--demo', when);
      if (tag) tag.hidden = !!cfg.verified;
      when.hidden = false;
    }
  }

  /* ---------- 6 · Set cards: built around her colour ---------- */
  function initSets(sec) {
    if (sec._jcgl) return;
    sec._jcgl = true;
    var saveTpl = sec.getAttribute('data-save-label') || 'Save [saving]';
    $$('[data-jc-gl-off]', sec).forEach(function (el) { setText(el, money(off(parseInt(el.getAttribute('data-jc-gl-off'), 10)))); });
    function list(card, slug) {
      var p = card.getAttribute('data-jc-gl-set'), o = partners(slug);
      if (p === 'twin') return [slug, slug];
      if (p === 'trio') return [slug, o[0], o[1]];
      if (p === 'fixed') return String(card.getAttribute('data-fixed') || '').split(',').filter(function (s) { return bySlug[s]; }).slice(0, 3);
      return [slug, o[0]];
    }
    function paint(card, slug, hop) {
      var l = list(card, slug).filter(function (s) { return bySlug[s]; });
      if (l.length < 2) return;
      var cs = l.map(function (s) { return bySlug[s]; });
      var stage = $('.jc-gl-set__stage', card), bags = $$('.jc-gl-set__bag', card);
      var key = l.join(',');
      var changed = card._key && card._key !== key;
      card._key = key;
      function apply() {
        bags.forEach(function (b, i) {
          var c = cs[i];
          if (!c) return;
          b.style.setProperty('--c', c.hex);
          var img = $('img', b);
          // snippets/jc-bag image: window.jcSetImg (layout) keeps its responsive srcset; without it, a plain swap
          if (img && typeof window.jcSetImg === 'function') window.jcSetImg(img, c.face);
          else if (img && img.getAttribute('src') !== c.face) { img.removeAttribute('srcset'); img.src = c.face; }
        });
      }
      if (changed && hop && !still() && inView(stage)) {
        stage.classList.remove('is-hop'); void stage.offsetWidth; stage.classList.add('is-hop');
        setTimeout(apply, 260);
        setTimeout(function () { stage.classList.remove('is-hop'); }, 820);
      } else apply();
      setText($('[data-jc-gl-set-names]', card), cs.map(function (c) { return c.name; }).join(' + '));
      var total = cs.reduce(function (s, c) { return s + c.price; }, 0) - off(cs.length);
      setText($('[data-jc-gl-set-total]', card), money(total));
      var sv = off(cs.length);
      setText($('[data-jc-gl-set-save]', card), sv >= 50 ? saveTpl.replace('[saving]', money(sv)) : '');
      var q = {}, order = [];
      cs.forEach(function (c) { if (!q[c.variant]) { q[c.variant] = 0; order.push(c.variant); } q[c.variant]++; });
      var btn = $('[data-jc-add-lines]', card);
      if (btn) {
        btn.setAttribute('data-jc-add-lines', JSON.stringify(order.map(function (id) { return { id: id, quantity: q[id] }; })));
        btn.setAttribute('data-jc-add-face', cs[0].face);
        btn.disabled = !cs.every(function (c) { return c.available; });
      }
    }
    var cards = $$('[data-jc-gl-set]', sec);
    cards.forEach(function (card) { if (card.getAttribute('data-jc-gl-set') !== 'fixed') paint(card, S.slug || D.current, false); else paint(card, D.current, false); });
    colourSubs.push(function (from, to) { cards.forEach(function (card) { if (card.getAttribute('data-jc-gl-set') !== 'fixed') paint(card, to, !!from); }); });
    var mix = $('[data-jc-gl-mix]', sec), proxy = $('[data-jc-gl-mix-proxy]', sec);
    if (mix) mix.addEventListener('click', function () {
      if (proxy && fold()) proxy.click();
      var target = $('[data-jc-tier-card="2"]') || $('#buy');
      if (target) target.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'center' });
    });
  }

  /* ---------- 9 · Final: ticks draw themselves once; he squishes ---------- */
  function initFinal(sec) {
    if (sec._jcgl) return;
    sec._jcgl = true;
    var face = $('[data-jc-gl-face-wrap]', sec);
    if (face) face.addEventListener('click', function () {
      if (still()) return;
      face.classList.remove('is-squish'); void face.offsetWidth; face.classList.add('is-squish');
      setTimeout(function () { face.classList.remove('is-squish'); }, 650);
    });
    var ticks = $('[data-jc-gl-ticks]', sec);
    if (ticks && !still() && 'IntersectionObserver' in window && !inView(ticks)) {
      $$('.is-done', ticks).forEach(function (li, i) { li.style.setProperty('--i', String(i)); });
      ticks.classList.add('is-armed');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          ticks.classList.add('is-drawing');
          if (face) setTimeout(function () { face.classList.add('is-squish'); setTimeout(function () { face.classList.remove('is-squish'); }, 650); }, 300);
        });
      }, { threshold: 0.4 });
      io.observe(ticks);
      setTimeout(function () { if (!ticks.classList.contains('is-drawing')) { /* never left undrawn if the observer can't fire */ } }, 0);
    }
    // One, two, three: one tab stop, arrows move and choose (jc.js does the choosing)
    var seg = $('[data-jc-gl-seg]', sec);
    if (seg) {
      var opts = $$('[role="radio"]', seg);
      var sync = function () { var on = opts.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0] || opts[0]; opts.forEach(function (o) { o.tabIndex = o === on ? 0 : -1; }); };
      seg.addEventListener('keydown', function (e) {
        var i = opts.indexOf(document.activeElement), j = -1;
        if (i < 0) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % opts.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + opts.length) % opts.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = opts.length - 1;
        if (j < 0) return;
        e.preventDefault();
        opts[j].focus();
        opts[j].click();
      });
      if ('MutationObserver' in window) new MutationObserver(sync).observe(seg, { subtree: true, attributes: true, attributeFilter: ['aria-checked'] });
      sync();
    }
  }

  /* ---------- Listen to the buy box ---------- */
  var watching = false;
  function watchFold() {
    if (watching) return;
    var root = foldRoot();
    if (!root || !('MutationObserver' in window)) return;
    watching = true;
    var f = fold();
    new MutationObserver(schedule).observe(f, { attributes: true, attributeFilter: ['data-count', 'data-tier'] });
    var nm = $('[data-jc-colour-name]', root);
    if (nm) new MutationObserver(schedule).observe(nm, { childList: true, characterData: true, subtree: true });
    $$('[data-jc-tier-price], [data-jc-slot-label], [data-jc-add-label]', root).forEach(function (el) { new MutationObserver(schedule).observe(el, { childList: true, characterData: true, subtree: true }); });
  }

  /* Added: the gift button says so for a moment; the hero's bag gives a happy squish */
  document.addEventListener('jc:added', function (e) {
    var t = e.detail && e.detail.trigger;
    if (!t || !t.closest) return;
    var b = t.closest('[data-jc-gl-add]');
    if (b) {
      var l = $('[data-jc-gl-label]', b);
      b.classList.add('is-added');
      if (l) setText(l, L.added);
      clearTimeout(b._t);
      b._t = setTimeout(function () { b.classList.remove('is-added'); render(); }, 1100);
    }
    var sc = $('[data-jc-gl-hero] [data-jc-gl-scene]');
    if (sc && inView(sc)) squish(sc);
  });
  // No buy box: the colour chips and runners-up still work (jc.js ignores them without it)
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('[data-jc-pick]');
    if (!p || fold() || !readData()) return;
    paintNoFold(p.getAttribute('data-jc-pick'));
  });

  var started = false;
  function boot(scope) {
    scope = scope || document;
    if (!readData()) return;
    var cfgL = json($('[data-jc-gl-labels]'));
    if (cfgL) Object.keys(cfgL).forEach(function (k) { if (cfgL[k]) L[k] = cfgL[k]; });
    var fcfg = json($('[data-jc-gl-fd-cfg]'));
    WHO = {};
    ((fcfg && fcfg.who) || []).forEach(function (w) { if (w.key) WHO[w.key] = w; });
    if (!S.who) {
      var want = new URL(location.href).searchParams.get('for') || store('jc-gl-for');
      if (want && WHO[want]) { S.who = WHO[want]; store('jc-gl-for', want); }
    }
    readState();
    initScenes(scope);
    $$('[data-jc-gl-hero]', scope).forEach(initHero);
    $$('[data-jc-gl-finder]', scope).forEach(initFinder);
    $$('[data-jc-gl-story]', scope).forEach(initStory);
    $$('[data-jc-gl-arrive]', scope).forEach(initArrive);
    $$('[data-jc-gl-sets]', scope).forEach(initSets);
    $$('[data-jc-gl-final]', scope).forEach(initFinal);
    watchFold();
    render();
    initBar();
  }
  function start() { if (started) return; started = true; boot(document); }
  window.jcGl = { boot: function (s) { if (started) boot(s); } };
  // jc.js (the buy box) runs after the sections' scripts: read the page once everything has run
  if (document.readyState === 'complete') setTimeout(start, 0);
  else { document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); }); window.addEventListener('load', start); }
  document.addEventListener('shopify:section:load', function (e) { D = null; bySlug = {}; byName = {}; boot(e.target); });
})();
